module.exports = __webpack_public_path__ + "static/media/Ally_app_3.272d6a60.jpg";